import { ILabel } from "./entities";
import { IJobProgress } from "./response";

export enum IFileType {
  Image = 'image',
  Video = 'video',
  StreamingVideo = 'streaming video',
  Audio = 'sound',
  YouTubeThumbnail = 'youtube thumbnail',
  VimeoThumbnail = 'vimeo thumbnail',
  WebsiteScreenshot = 'website screenshot',
  TrackingImage = 'tracking image',
  ZPP = 'zpp',
  UARPackage = 'uarzip',
  LookUpImage = 'lookup image',
  Model3D = '3d model',
  Image360 = '360 image',
  Video360 = '360 video',
  ZPT = 'zpt',
  Icon = 'icon',
  CoverImage = 'cover image'
}

export enum IFileStatus {
  Pending = 'pending',
  Ready = 'ready',
  Error = 'error',
  Deleted = 'deleted',
  Success = 'success' // v2
}

export interface IFile {
  id: string
  url: string
  type: IFileType
  caption: string
  filename: string
  status: IFileStatus
  error: string
  date: string
  statusURL: string
  uploadedBy: string
  extension: string
  canDelete: boolean
  source: string
  binned: boolean
  binnedAt: string
  canRestore: boolean
  workspaceId: string
  folderId: string | null
  labels: ILabel[]
  meta: Record<string, unknown>
  version: number
  workflowStatusId: string | null
  size: number
}

export interface IFileImage extends IFile {
  type: IFileType.Image
}

export interface IFileImage360 extends IFile {
  type: IFileType.Image360
}

export interface IFileAudio extends IFile {
  type: IFileType.Audio
}

export interface IFileTrackingImage extends IFile {
  type: IFileType.TrackingImage
}

export interface IFileVideo extends IFile {
  type: IFileType.StreamingVideo
}

export interface IFileVideo360 extends IFile {
  type: IFileType.Video360
}

export interface IFileStreamingVideo extends IFile {
  type: IFileType.StreamingVideo
}

export interface IFileModel3D extends IFile {
  type: IFileType.Model3D
  meta: { animations: string[], dimensions: { x: number, y: number, z: number } }
}

export interface IFileZPT extends IFile {
  type: IFileType.ZPT
  meta: { zptUrl: string, imageUrl: string }
}

export interface IFileIcon extends IFile {
  type: IFileType.Icon
}

export interface IFileCoverImage extends IFile {
  type: IFileType.CoverImage
}

export interface IThumbnail {
  W: number
  H: number
  Quality: number // 1 to 100
  FitMode?: "fit"
}

export interface IProgressCallback {
  (percentage: number, info: IJobProgress): void
}

export type IFileAny = IFileImage | IFileImage360 | IFileTrackingImage | IFileVideo | IFileVideo360 | IFileStreamingVideo | IFileModel3D | IFileAudio | IFileIcon | IFileCoverImage;

type IFileTypeMapSpec = {
  [key in IFileType]: IFileAny
}

export interface IFileTypeMap extends IFileTypeMapSpec {
  [IFileType.Image]: IFileImage
  [IFileType.Image360]: IFileImage360
  [IFileType.TrackingImage]: IFileTrackingImage
  [IFileType.Video]: IFileVideo
  [IFileType.Video360]: IFileVideo360
  [IFileType.StreamingVideo]: IFileStreamingVideo
  [IFileType.Model3D]: IFileModel3D
  [IFileType.Audio]: IFileAudio
  [IFileType.Icon]: IFileIcon
  [IFileType.CoverImage]: IFileCoverImage
}

export interface IUploadFileOptions {
  caption?: string
  workflowStatusId?: string | null
  folderId?: string | null
}
